"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathBasename = void 0;
function pathBasename(path) {
    return path.split("/").reverse()[0];
}
exports.pathBasename = pathBasename;
//# sourceMappingURL=pathBasename.js.map